import type { SkipCondition, StepConfig } from "./flowConfig.types";

export interface FlowConditionContext {
  is_family_kyc: boolean;
  skip_kyc: boolean;
}

export const DEFAULT_FLOW_CONDITIONS: FlowConditionContext = {
  is_family_kyc: false,
  skip_kyc: false,
};

export function evaluateSkipIf(
  skipIf: SkipCondition | undefined,
  ctx: FlowConditionContext,
): boolean {
  if (!skipIf) return false;
  switch (skipIf) {
    case "is_family_kyc":
      return ctx.is_family_kyc;
    case "!is_family_kyc":
      return !ctx.is_family_kyc;
    case "skip_kyc":
      return ctx.skip_kyc;
    case "!skip_kyc":
      return !ctx.skip_kyc;
    default:
      return false;
  }
}

export function findFirstStep(
  steps: StepConfig[],
  ctx: FlowConditionContext,
): StepConfig | null {
  for (const step of steps) {
    if (!evaluateSkipIf(step.skip_if, ctx)) {
      return step;
    }
  }
  return null;
}
